<a [href]="url" class="usp-link">
  <img [alt]="icon + ' icon'" [src]="'assets/icons/' + icon + '.svg'" class="usp-link__icon" />
  <ng-content></ng-content>
</a>
